
















import { defineComponent, PropType, computed } from "@nuxtjs/composition-api";
import type { Product } from "@wemade-vsf/catalog/lib/runtime/product/types";
import { SfQuantitySelector } from "~/storefrontUI/components";
import { usePriceRequest } from "@wemade-vsf/catalog/lib/runtime/product/composables/usePriceRequest";
export default defineComponent({
    name: "ProductCardActions",
    props: {
        product: {
            type: Object as PropType<Product>,
            required: true,
        },
        actions: {
            type: Array as PropType<string[]>,
            default: () => ["link", "cart"],
        },
        showQuantity: {
            type: Boolean,
            default: true,
        },
        showAddToCart: {
            type: Boolean,
            default: true,
        },

        isQuoteProduct: {
            type: Boolean,
            default: false,
        },
        qty: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    model: {
        prop: "qty",
    },
    components: {
        AddToCart: () =>
            import("components/catalog/Product/ProductCard/AddToCart.vue"),
        PriceRequestButton: () =>
            import("components/catalog/Product/PriceRequestButton.vue"),
        SfQuantitySelector,
    },
    setup(props) {
        const showLink = computed(() => props.actions.includes("link"));
        const showPriceRequest = computed(() =>
            props.actions.includes("quote")
        );

        const { openPriceRequestModal } = usePriceRequest();

        return {
            showLink,
            showPriceRequest,
            openPriceRequestModal,
        };
    },
});
